import React from 'react'
import useStyles from './Styles'
import { IProps } from './Interface'
import { Box, IconButton } from '@material-ui/core'
import { Cancel, CheckCircle } from '@material-ui/icons'

const EditIcons: React.FC<IProps> = ({ visible, handleCancel, handleConfirm }) => {
  const classes = useStyles({ visible })

  return (
    <Box className={classes.root}>
      <IconButton id={'accept-button'} onClick={handleConfirm} className={classes.button}>
        <CheckCircle className={classes.accept} fontSize="small" />
      </IconButton>
      <IconButton id={'reject-button'} onClick={handleCancel} className={classes.button}>
        <Cancel className={classes.reject} fontSize="small" />
      </IconButton>
    </Box>
  )
}

EditIcons.defaultProps = {
  visible: false,
  handleCancel: () => {},
  handleConfirm: () => {}
}

export default EditIcons
